module.exports = __webpack_public_path__ + "img/frame (178).78cdda49.jpg";